import { openModal } from "../modal";

export function messageTimer(time, modal) {
  let timeInterval = setInterval(() => {
    setStorageData(time);

    if (time > 0) {
      const freeLessonStorage = JSON.parse(
        localStorage.getItem("freeLessonStatus")
      );

      if (!freeLessonStorage?.status) {
        localStorage.removeItem("freeLesson");
        localStorage.removeItem("freeLessonStatus");
        clearInterval(timeInterval);
      }
    }

    if (time === 0 && modal && !window.location.href.includes("/test/")) {
      const freeLessonStorage = JSON.parse(localStorage.getItem("freeLesson"));

      const { pagePath, redirectPath } = pathes(freeLessonStorage?.url);
      if (pagePath !== redirectPath) {
        openModal(modal);
      }
      clearInterval(timeInterval);
    }
    --time;
  }, 1000);
}

function setStorageData(time) {
  const freeLessonStorage = JSON.parse(localStorage.getItem("freeLesson"));

  if (time >= 0) {
    localStorage.setItem(
      "freeLesson",
      JSON.stringify({
        ...freeLessonStorage,
        timer: time,
      })
    );
  }
}

function pathes(url) {
  const pagePath = window.location.pathname;
  const redirectPath = new URL(url)?.pathname;

  return { pagePath, redirectPath };
}
